<div class="errorHandler">
    <span [translate]="'COMMON.ERROR_TITLE_TEXT'" 
    [translateParams]="{ supportEmail: supportEmailId }"></span>
    <span (click)="errorPopUp($event)">{{ 'COMMON.ERROR_MESSAGE_TEXT' | translate}}</span>
    <span>{{ 'COMMON.ERROR_CONTENT' | translate}}</span>
</div>